/**
 * @generated SignedSource<<1a6723aa840b24a2a3f48c074e93bc1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedItemsWrapper_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedRelatedItemsWrapper_user";
};
export type SharedRelatedItemsWrapper_user$key = {
  readonly " $data"?: SharedRelatedItemsWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRelatedItemsWrapper_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b4431e85030d7027cabf5a5ab0dfce23";

export default node;
